/*
DESIGN SPEC — Minimal Modern

Colors:
- Background: #FFFFFF (primary), #FAFAFA (secondary/page bg)
- Text: #18181B (primary), #71717A (secondary/muted)
- Border: #E4E4E7 (default), #D4D4D8 (hover/strong)
- Accent: #2563EB (pick ONE accent color — used for links, primary buttons, focus states only)
- Semantic: #16A34A (success), #DC2626 (danger), #D97706 (warning)

Typography:
- Font: Inter or system-ui, sans-serif. One family only.
- Scale: 12 / 14 / 16 / 20 / 24 / 32 / 40px
- Weights: 400 (body), 500 (headings/emphasis) — avoid 600/700, they look heavy
- Line height: 1.6 body, 1.2 headings
- Sentence case everywhere, no ALL CAPS except tiny labels

Spacing scale (use ONLY these values, no arbitrary px):
4, 8, 12, 16, 24, 32, 48, 64

Borders & radius:
- 1px solid border color, radius 8px for controls, 12px for cards
- No shadows except a subtle 1px ring on focus states

Motion:
- Transitions 150–200ms ease-out on hover/focus only
- No bouncy/springy easing — keep it flat and quick

Rules:
- No gradients, no drop shadows, no decorative color
- Max one accent color used sparingly (primary CTA, active states, links)
- Whitespace is the main visual tool — err on the side of more padding/margin
*/

const spacingScale = [4, 8, 12, 16, 24, 32, 48, 64];

export const theme = {
  colors: {
    background: "#FFFFFF",
    backgroundSecondary: "#FAFAFA",
    text: "#18181B",
    textMuted: "#71717A",
    border: "#E4E4E7",
    borderStrong: "#D4D4D8",
    accent: "#2563EB",
    accentHover: "#1D4ED8",
    success: "#16A34A",
    danger: "#DC2626",
    warning: "#D97706",
    white: "#FFFFFF",
  },
  typography: {
    fontFamily:
      'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    sizes: {
      xs: "12px",
      sm: "14px",
      md: "16px",
      lg: "20px",
      xl: "24px",
      "2xl": "32px",
      "3xl": "40px",
    },
    weights: {
      regular: 400,
      medium: 500,
    },
    lineHeights: {
      body: 1.6,
      heading: 1.2,
    },
  },
  spacing: (index) => `${spacingScale[index]}px`,
  spacingScale,
  radii: {
    control: "8px",
    card: "12px",
  },
  transitions: {
    default: "150ms ease-out",
    slow: "200ms ease-out",
  },
  layout: {
    maxWidth: "960px",
    maxWidthNarrow: "480px",
    modalMaxWidth: "420px",
    profileSize: "96px",
    galleryHeight: "160px",
  },
};

export default theme;
